import React from "react";

/**
 * Timeline row for the canonical activity timeline.
 * @param {Object} props
 * @param {string} props.t — timestamp (formatted).
 * @param {string} props.who — actor label.
 * @param {React.ReactNode} props.action — description.
 */
export function TimelineRow({ t, who, action }) {
  return (
    <div className="ds-timeline-row">
      <span className="ds-timeline-t">{t}</span>
      <span><span className="ds-timeline-who">{who}</span> · {action}</span>
    </div>
  );
}
